import { api_url } from "../configiration/config";
import { axiosClone } from "./../axiosClone";
import axios from 'axios';

// get blog sections
export async function getListPropertyData(){
    return await axiosClone.get(`${api_url}/headers/list-your-property`);
}
//send list property request
export async function sendPropertyRequest(propertyData){
   await axios({
        url: `${api_url}/list-your-property`,
        method: 'post',
        data: propertyData
    })
}